import './styles/global.scss'
import './../public/fonts/Ramona/style.css'

import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { store } from './store/index'
import { Provider } from 'react-redux'

import Experience from './webgl/Experience'
import Interface from './ui/Interface'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
  // <StrictMode>
  <Provider store={store}>
    <Interface />
    <Experience />
  </Provider>,
  // </StrictMode>,
)
